/**
 * Fixes the value by trimming whitespace if specified.
 *
 * @param inString - The input string to process and format
 * @param trim - Whether to trim whitespace from the string
 */
export const valueFix = (inString: string, trim: boolean): string => {
  let n = inString;
  /* istanbul ignore else */
  if (trim) n = n.replace(/\s+/g, " ").trim();
  return n;
};
